import React from 'react';

export function SvgCropTool(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00323 2.67001C7.55552 2.67001 8.00323 3.11773 8.00323 3.67001V6.00339H15.3366C16.0438 6.00339 16.7221 6.28434 17.2222 6.78444C17.7223 7.28453 18.0033 7.96281 18.0033 8.67005V16.0033H20.3366C20.8889 16.0033 21.3366 16.4511 21.3366 17.0033C21.3366 17.5556 20.8889 18.0033 20.3366 18.0033H18.0033V20.3367C18.0033 20.889 17.5555 21.3367 17.0033 21.3367C16.451 21.3367 16.0033 20.889 16.0033 20.3367V18.0033H8.6699C7.96266 18.0033 7.28438 17.7224 6.78428 17.2223C6.28419 16.7222 6.00323 16.0439 6.00323 15.3367V8.00339H3.66992C3.11764 8.00339 2.66992 7.55567 2.66992 7.00339C2.66992 6.4511 3.11764 6.00339 3.66992 6.00339H6.00323V3.67001C6.00323 3.11773 6.45095 2.67001 7.00323 2.67001ZM8.00323 8.00339V15.3367C8.00323 15.5135 8.07347 15.6831 8.1985 15.8081C8.32352 15.9331 8.49309 16.0033 8.6699 16.0033H16.0033V8.67005C16.0033 8.49324 15.933 8.32367 15.808 8.19865C15.683 8.07363 15.5134 8.00339 15.3366 8.00339H8.00323Z"
        fill="currentColor"
      />
    </svg>
  );
}
